// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInfoBanner-cls1_mlV","cls2":"CiterightInfoBanner-cls2_SU- CiterightInfoBanner-cls1_mlV"};